<template>
  <div class="national-main" :style="`padding-top:${barHeight}px`">
    <van-nav-bar class="van-bar" left-arrow @click-left="closeWeb">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
      </template>
      <template #right>
        <span class="tit-right" @click="handleToRule">
          <img class="left-nav" src="@/assets/packageAssets/common/rules02.png" alt="" />
        </span>
      </template>
    </van-nav-bar>

    <div class="national-con" :style="{ 'margin-top': `-${barHeight + 46}px` }">
      <div class="national-head">
        <img class="head-img-back" src="./images/main-bg.png" />

        <div class="head-img">
          <img v-if="$i18n.locale === 'es'" :src="getMatchTitle('tit-bg-es')" />
          <img v-else-if="$i18n.locale === 'pt'" :src="getMatchTitle('tit-bg-pt')" />
          <img v-else :src="getMatchTitle('tit-bg-en')" />
        </div>
      </div>

      <div class="main-con">
        <div class="act-date">
          <template v-if="actInfo">
            <div v-if="!actInfo.started" class="act-enddate">
              {{ $t('lang.commonM.k205') }}:
              <i>{{ countdownResult.hours }}:{{ countdownResult.minutes }}:{{ countdownResult.seconds }}</i>
            </div>
            <div v-else class="act-enddate">
              {{ $t('lang.commonM.k206') }}:
              <i>{{ countdownResult.days }}:{{ countdownResult.hours }}:{{ countdownResult.minutes }}:{{ countdownResult.seconds }}</i>
            </div>
          </template>
          <div style="height: 12px"></div>
          <div class="act-range">{{ mexActStartTime }} - {{ mexActEndTime }}</div>
        </div>

        <div v-if="actInfo && !!actInfo.started" class="points-rank">
          <div class="pr-item">
            <div>{{ $t('lang.commonM.k221') }}</div>
            <div v-if="actInfo">{{ actInfo.score || 0 }}</div>
          </div>
          <div style="width: 15px"></div>
          <div class="pr-item">
            <div>{{ $t('lang.commonM.k222') }}</div>
            <template v-if="actInfo">
              <div v-if="!actInfo.rank">--</div>
              <div v-else>{{ actInfo.rank }}</div>
            </template>
          </div>
        </div>

        <div class="part-block">
          <div class="part-head">{{ $t('lang.commonM.k208') }}</div>
          <div v-if="actInfo && !!actInfo.started" class="part-tips">{{ $t('lang.commonM.k244') }}</div>
          <div v-else class="part-tips">{{ $t('lang.commonM.k259') }}</div>
          <div class="national-gift">
            <div class="gift-round">
              <div class="gift-cost">+1 {{ $t('lang.commonM.k260') }}</div>
              <img src="@/assets/packageAssets/common/Balloons.png" alt="" />
              <div class="gift-name">{{ $t('lang.commonM.k304') }}</div>
            </div>
            <div class="gift-round">
              <div class="gift-cost">+3 {{ $t('lang.commonM.k260') }}</div>
              <img src="@/assets/packageAssets/common/Ring.png" alt="" />
              <div class="gift-name">{{ $t('lang.commonM.k211') }}</div>
            </div>
            <div class="gift-round">
              <div class="gift-cost">+5 {{ $t('lang.commonM.k260') }}</div>
              <img src="@/assets/packageAssets/common/Rose.png" alt="" />
              <div class="gift-name">{{ $t('lang.commonM.k212') }}</div>
            </div>
            <div class="gift-round">
              <div class="gift-cost">+15 {{ $t('lang.commonM.k260') }}</div>
              <img src="@/assets/packageAssets/common/Kiss.png" alt="" />
              <div class="gift-name">{{ $t('lang.commonM.k305') }}</div>
            </div>
            <div class="gift-round">
              <div class="gift-cost">+50 {{ $t('lang.commonM.k260') }}</div>
              <img src="@/assets/packageAssets/common/Treasure.png" alt="" />
              <div class="gift-name">{{ $t('lang.commonM.k306') }}</div>
            </div>
          </div>
        </div>

        <div class="part-block">
          <div class="part-head">{{ $t('lang.commonM.k215') }}</div>
          <div class="part-tips">{{ $t('lang.commonM.k216') }}</div>
          <div class="part-percent">
            <div class="part-per-block">
              <div>
                <div class="part-per-tips">
                  <div>{{ $t('lang.commonM.k217') }}</div>
                  <span>{{ percentData.percent1.num }}/10</span>
                </div>
                <div class="part-per-bar">
                  <div class="part-per-track" :style="{ width: `${percentData.percent1.rate}%` }"></div>
                </div>
              </div>
              <div style="width: 100%; height: 20px"></div>
              <div>
                <div class="part-per-tips">
                  <div>{{ $t('lang.commonM.k217') }}</div>
                  <span>{{ percentData.percent2.num }}/15</span>
                </div>
                <div class="part-per-bar">
                  <div class="part-per-track" :style="{ width: `${percentData.percent2.rate}%` }"></div>
                </div>
              </div>
              <div style="width: 100%; height: 20px"></div>
              <div>
                <div class="part-per-tips">
                  <div>{{ $t('lang.commonM.k217') }}</div>
                  <span>{{ percentData.percent3.num }}/20</span>
                </div>
                <div class="part-per-bar">
                  <div class="part-per-track" :style="{ width: `${percentData.percent3.rate}%` }"></div>
                </div>
              </div>
            </div>
            <div style="width: 10px"></div>
            <div class="part-per-reward">
              <div>
                70
                <img :src="getMatchImg('beans')" />
              </div>
              <div style="width: 100%; height: 20px"></div>
              <div>
                80
                <img :src="getMatchImg('beans')" />
              </div>
              <div style="width: 100%; height: 20px"></div>
              <div>
                100
                <img :src="getMatchImg('beans')" />
              </div>
            </div>
          </div>
        </div>

        <div class="part-block">
          <div class="part-head">{{ $t('lang.commonM.k218') }}</div>
          <div class="part-tips">{{ $t('lang.commonM.k219') }}</div>
          <div class="national-reward">
            <div class="national-item">
              <div class="reward-num">No.1</div>
              <div class="reward-coins">
                5000
                <img class="coins-icon" :src="getMatchImg('beans')" />
              </div>
            </div>
            <div class="national-item">
              <div class="reward-num">No.2</div>
              <div class="reward-coins">
                3000
                <img class="coins-icon" :src="getMatchImg('beans')" />
              </div>
            </div>
            <div class="national-item">
              <div class="reward-num">No.3</div>
              <div class="reward-coins">
                2000
                <img class="coins-icon" :src="getMatchImg('beans')" />
              </div>
            </div>
            <div class="national-item">
              <div class="reward-num">No.4-10</div>
              <div class="reward-coins">
                800
                <img class="coins-icon" :src="getMatchImg('beans')" />
              </div>
            </div>
          </div>

          <div class="btn-block" v-if="actInfo && actInfo.started">
            <div class="national-btn" @click="handleToRank">{{ $t('lang.commonM.k220') }}</div>
          </div>
        </div>

        <div class="btn-block" v-if="actInfo && !actInfo.started">
          <div class="national-btn" @click="handleGotIt">{{ $t('lang.gotit') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { holidayActBaseInfoBr } from './apidir/api.js'

import countDown from '@/mixin/count-down.js'

// en
import vavaTitBgEn from './images/vava/female-bg-en.png'
import echoTitBgEn from './images/echo/female-bg-en.png'
import joychatTitBgEn from './images/joychat/female-bg-en.png'

// es
import vavaTitBgEs from './images/vava/female-bg-es.png'
import echoTitBgEs from './images/echo/female-bg-es.png'
import joychatTitBgEs from './images/joychat/female-bg-es.png'

// pt
import vavaTitBgPt from './images/vava/female-bg-pt.png'
import echoTitBgPt from './images/echo/female-bg-pt.png'
import joychatTitBgPt from './images/joychat/female-bg-pt.png'

export default {
  mixins: [countDown],
  data() {
    return {
      actInfo: null,
      percentData: {
        percent1: {
          num: 0,
          rate: 0
        },
        percent2: {
          num: 0,
          rate: 0
        },
        percent3: {
          num: 0,
          rate: 0
        }
      },
      mexActStartTime: '',
      mexActEndTime: ''
    }
  },
  created() {
    this.getPackageName()
    this.fetchData()
  },
  methods: {
    handleToRule() {
      this.$router.push({ path: '/holiday-rules-female-br', query: { from: 'holiday-main-female-br' } })
    },
    handleToRank() {
      this.$router.push({ path: '/holiday-rank-female-br', query: { from: 'holiday-main-female-br' } })
    },
    handleGotIt() {
      this.closeWeb()
    },
    getMatchTitle(imgname) {
      const imgsMap = {
        'tit-bg-en': {
          vava: vavaTitBgEn,
          echo: echoTitBgEn,
          joychat: joychatTitBgEn
        },
        'tit-bg-es': {
          vava: vavaTitBgEs,
          echo: echoTitBgEs,
          joychat: joychatTitBgEs
        },
        'tit-bg-pt': {
          vava: vavaTitBgPt,
          echo: echoTitBgPt,
          joychat: joychatTitBgPt
        }
      }

      // 按包名判断
      const appName = this.getAppName()
      if (this.appNameFlag('vava', appName)) {
        return imgsMap[imgname]['vava']
      }
      if (this.appNameFlag('echo', appName)) {
        return imgsMap[imgname]['echo']
      }
      if (this.appNameFlag('joychat', appName)) {
        return imgsMap[imgname]['joychat']
      }
      if (this.appNameFlag('joylink', appName)) {
        return imgsMap[imgname]['joylink']
      }
      if (this.appNameFlag('goparty', appName)) {
        return imgsMap[imgname]['goparty']
      }
    },
    // 获取数据
    fetchData() {
      holidayActBaseInfoBr().then((resData) => {
        this.actInfo = resData || null

        if (this.actInfo.startTimestamp) {
          this.mexActStartTime = this.handletMoment(this.actInfo.startTimestamp, 'YYYY/MM/DD HH:mm:ss')
        }
        if (this.actInfo.endTimestamp) {
          this.mexActEndTime = this.handletMoment(this.actInfo.endTimestamp, 'YYYY/MM/DD HH:mm:ss')
        }

        // 初始化倒计时
        if (this.actInfo.countdown) {
          this.initCountDown(resData.countdown, !!this.actInfo.started)
        }

        if (this.actInfo.score > 0 && this.actInfo.score <= 10) {
          this.percentData.percent1.num = this.actInfo.score
          this.percentData.percent1.rate = (+this.actInfo.score / 10) * 100

          this.percentData.percent2.num = this.actInfo.score
          this.percentData.percent2.rate = (+this.actInfo.score / 15) * 100

          this.percentData.percent3.num = this.actInfo.score
          this.percentData.percent3.rate = (+this.actInfo.score / 20) * 100
          return
        }

        if (this.actInfo.score > 10 && this.actInfo.score <= 15) {
          this.percentData.percent1.num = 10
          this.percentData.percent1.rate = 100

          this.percentData.percent2.num = this.actInfo.score
          this.percentData.percent2.rate = (+this.actInfo.score / 15) * 100

          this.percentData.percent3.num = this.actInfo.score
          this.percentData.percent3.rate = (+this.actInfo.score / 20) * 100
          return
        }

        if (this.actInfo.score > 15 && this.actInfo.score <= 20) {
          this.percentData.percent1.num = 10
          this.percentData.percent1.rate = 100

          this.percentData.percent2.num = 15
          this.percentData.percent2.rate = 100

          this.percentData.percent3.num = this.actInfo.score
          this.percentData.percent3.rate = (+this.actInfo.score / 20) * 100
          return
        }

        if (this.actInfo.score > 20) {
          this.percentData.percent1.num = 10
          this.percentData.percent1.rate = 100

          this.percentData.percent2.num = 15
          this.percentData.percent2.rate = 100

          this.percentData.percent3.num = 20
          this.percentData.percent3.rate = 100
          return
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.national-main {
  width: 100%;
  min-height: 100vh;
  background: #20a438;

  .national-con {
    .national-head {
      width: 100%;
      position: relative;
      .head-img-back {
        width: 100%;
      }
      .head-img {
        position: absolute;
        top: 75px;
        z-index: 9;
        padding-top: 10px;
        width: 100%;
        img {
          display: block;
          width: 100%;
        }
      }
    }

    .main-con {
      position: relative;
      overflow: hidden;
      padding-bottom: 79px;
      margin-top: -290px;

      .act-date {
        width: 355px;
        height: 87px;
        margin: 0 auto;
        border-radius: 12px;
        border: 0.5px solid rgba(255, 255, 255, 0.5);
        background: rgba(5, 107, 0, 0.8);
        backdrop-filter: blur(10.873126983642578px);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .act-enddate {
          font-family: TikTok Sans;
          font-weight: 600;
          font-size: 17px;
          color: #ffffff;
          line-height: 22px;
          text-align: right;
          i {
            color: #ffcf00;
          }
        }
        .act-range {
          font-family: TikTok Sans;
          font-weight: 400;
          font-size: 15px;
          color: #ffffff;
          line-height: 20px;
          text-align: right;
        }
      }

      .points-rank {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 16px;
        .pr-item {
          width: 170px;
          height: 66px;
          padding: 10px;
          background: #f4faf2;
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          div:nth-child(1) {
            font-family: TikTok Sans;
            font-weight: 400;
            font-size: 15px;
            color: #076229;
            line-height: 20px;
          }
          div:nth-child(2) {
            font-family: TikTok Sans;
            font-weight: bold;
            font-size: 20px;
            color: #076229;
            line-height: 24px;
          }
        }
      }

      .part-block {
        width: 355px;
        min-height: 250px;
        margin: 16px auto 0;
        padding-bottom: 24px;
        background: #f4faf2;
        border-radius: 12px;
        .part-head {
          width: 355px;
          background: #feffae;
          border-radius: 12px 12px 0px 0px;
          font-family: TikTok Sans;
          font-size: 17px;
          color: #076229;
          line-height: 42px;
          font-weight: 600;
          text-align: center;
        }
        .part-tips {
          width: 100%;
          padding: 16px;
          font-family: TikTok Sans;
          font-weight: 400;
          font-size: 15px;
          color: #576f60;
          line-height: 20px;
          font-style: normal;
        }
        .national-gift {
          width: 100%;
          min-height: 30px;
          margin: 10px auto 16px;
          padding: 0 10px;
          display: flex;
          align-items: flex-start;
          justify-content: space-evenly;
          .gift-round {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .gift-cost {
              background: #4dab00;
              border-radius: 19px;
              padding: 2px 4px;
              min-width: 36px;
              font-family: TikTok Sans;
              font-weight: 600;
              font-size: 8px;
              color: #ffffff;
              line-height: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            img {
              width: 40px;
              height: 40px;
              margin-top: 6px;
            }
            .gift-name {
              font-family: TikTok Sans;
              font-weight: 400;
              font-size: 12px;
              color: #547a6c;
              line-height: 16px;
              margin-top: 14px;
              text-align: center;
            }
          }
        }
        .national-reward {
          width: 100%;
          padding: 0 16px;
          min-height: 116px;
          margin: 0 auto;

          .national-item {
            font-family: TikTok Sans;
            font-weight: 400;
            font-size: 15px;
            color: #295948;
            line-height: 20px;
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
            .reward-coins {
              display: flex;
              align-items: center;
              font-weight: bold;
              .coins-icon {
                width: 16px;
                height: 16px;
                margin-left: 4px;
              }
            }
          }
        }
        .part-percent {
          width: 100%;
          padding: 0 16px 20px;
          display: flex;
          &:last-child {
            padding-bottom: 0;
          }
          .part-per-block {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: space-around;
            > div {
              width: 100%;
              .part-per-tips {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 4px;
                div {
                  font-family: TikTokSans;
                  font-weight: 400;
                  font-size: 15px;
                  color: #576f60;
                  line-height: 20px;
                }
                span {
                  font-family: TikTokSans;
                  font-weight: 400;
                  font-size: 15px;
                  color: #576f60;
                  line-height: 20px;
                }
              }
              .part-per-bar {
                width: 100%;
                height: 10px;
                background: #dedede;
                border-radius: 5px;
                .part-per-track {
                  width: 10px;
                  height: 10px;
                  background: #4dab00;
                  border-radius: 5px;
                }
              }
            }
          }
          .part-per-reward {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            justify-content: space-around;
            div {
              display: flex;
              align-items: center;

              font-family: TikTokSans;
              font-weight: bold;
              font-size: 17px;
              color: #295948;
              line-height: 22px;
              text-align: center;
              img {
                width: 20px;
                height: 20px;
              }
            }
          }
        }
      }
      .task-block {
        padding: 0 16px;
        .part-tips-b {
          font-family: TikTok Sans;
          font-weight: 500;
          font-size: 17px;
          color: #ffffff;
          line-height: 22px;
          margin-top: 32px;
          text-align: left;
        }
        .part-task {
          margin-top: 13px;
          font-family: TikTok Sans;
          font-weight: 400;
          font-size: 15px;
          color: #ffffff;
          line-height: 20px;
          display: flex;
          justify-content: space-between;
        }
      }

      .btn-block {
        display: block;
        width: 100%;
        margin: 30px auto 8px;
        text-align: center;
        .national-btn {
          min-width: 275px;
          display: inline-block;
          padding: 0 15px;
          background: #ffec00;
          border-radius: 27px;
          font-family: TikTok Sans;
          font-weight: 500;
          font-size: 17px;
          color: #11470e;
          line-height: 42px;
          text-align: center;
          &.btn-disable {
            color: #edeef2;
            background: #a4a9bd;
          }
        }
      }
    }
  }
}

.act-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;

  .dia-bg {
    width: 315px;
    border-radius: 16px;
    background: linear-gradient(180deg, #84ef98 0%, #deffe4 100%);

    .con-block {
      width: 315px;
      border-radius: 16px;
      background: url(./images/dia-bg.png) top left / 100% auto no-repeat;
      padding: 35px 30px 30px;

      .gifts-tit {
        font-family: 'TikTok Sans';
        font-weight: normal;
        font-size: 20px;
        color: #004700;
        line-height: 20px;
        text-align: center;
        font-weight: bold;
      }

      .gifts {
        margin-top: 24px;
        margin-bottom: 20px;
        width: 100%;
        padding: 16px;
        border-radius: 8px;
        border: 1px solid #fffad7;
        background: linear-gradient(180deg, rgba(32, 164, 56, 0.2) 0%, rgba(241, 255, 48, 0.2) 100%);
        box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1) inset;

        display: flex;
        align-items: center;
        justify-content: center;

        .gift-gap {
          width: 12px;
        }

        & > div {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .img-wrap {
            width: 40px;
            height: 40px;
            padding: 5px;
            border-radius: 8px;
            background: #ffffff;
            img {
              width: 100%;
            }
          }
          .rewards-name {
            font-family: TikTok Sans;
            font-weight: 400;
            font-size: 12px;
            color: #547a6c;
            line-height: 22px;
            margin-top: 4px;
            text-align: center;
          }
          .rewards-count {
            font-family: TikTok Sans;
            font-weight: bold;
            font-size: 17px;
            color: #295948;
            line-height: 22px;
            font-style: italic;
            margin-top: 2px;
          }
        }
      }
      .gifts-confirm {
        width: 255px;
        line-height: 40px;
        padding: 10px;
        border-radius: 30px;
        background: #ffec00;

        font-family: Inter;
        font-size: 20px;
        font-weight: bold;
        color: #11470e;
        line-height: 20px;
        text-align: center;
      }
    }
  }
}
</style>
